import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useI18n } from "@/i18n";

const PHONE = "33743965188";

export const WhatsAppLink = ({ className = "", testId = "whatsapp-contact-link", children }) => {
  const { t } = useI18n();
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(t.whatsapp.message)}`;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" aria-label={t.whatsapp.label} title={t.whatsapp.label} data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 ${className}`}>
      <MessageCircle className="h-5 w-5" aria-hidden="true" />
      {children}
    </a>
  );
};

export const WhatsAppButton = () => {
  const { t } = useI18n();
  const { pathname } = useLocation();
  if (["/contact", "/commander"].includes(pathname)) return null;
  return (
    <WhatsAppLink testId="whatsapp-floating-button" className="fixed bottom-5 right-4 z-40 bg-[#25D366] px-4 py-3 text-sm font-bold text-[#07150C] shadow-2xl transition-transform hover:-translate-y-1 sm:right-6">
      <span className="hidden sm:inline">{t.whatsapp.short}</span>
    </WhatsAppLink>
  );
};